import React from "react";
import { useTheme } from "../../context/ThemeContext.jsx";
import PillBadge from "./PillBadge.jsx";
import { FALLTYP_LABELS, FALLTYP_COLORS, FALLTYP_COLORS_LIGHT } from "../../constants/status.js";
export default function FalltypBadge({
  falltyp,
  size = "sm",
  className = ""
}) {
    const ft = String(falltyp || "NORMAL").toUpperCase();
  if (ft === "NORMAL") return null;
  const label = FALLTYP_LABELS[ft] || ft;
  const colors = FALLTYP_COLORS[ft];
  if (!colors) return null;
  const badgeSize = size === "xs" ? "xs" : "sm";
  return <PillBadge label={label} toneClassName={colors} size={badgeSize} className={`uppercase tracking-wide font-semibold ${className}`.trim()} title={`Falltyp: ${label}`} aria-label={`Falltyp ${label}`} />;
}